import "./DetailingItem.scss";
import { useRef, useState } from "react";
import { IconSvg } from "../../../../../../../../../utils/constants/icons/iconSvg.constant";
import { classNames } from "../../../../../../../../../utils/helpers/classNames";

export const DetailingItem = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const itemHandler = () => {
    const item = ref?.current;
    const scrollHeight = item?.scrollHeight;

    if (!item || !scrollHeight) return;

    if (isOpen) {
      item.style.height = "60px";
      setIsOpen(false);

      return;
    }

    item.style.height = `${scrollHeight}px`;
    setIsOpen(true);
  };

  return (
    <div ref={ref} className={classNames("detailing-item", { "detailing-item--open": isOpen })}>
      <div className="detailing-item__ip-container detailing-list__column--ip">
        <div
          className={
          classNames(
            "detailing-item__expand-icon",
            { "detailing-item__expand-icon--open": isOpen }
          )}
          onClick={itemHandler}
        >
          <IconSvg tag="roundedPlus" />
        </div>
        <div className="detailing-item__ip">{item.ip}</div>
        <div className="detailing-item__download-icon">
          <IconSvg tag="download" />
        </div>
      </div>
      <div className="detailing-item__traffic-container detailing-list__column--traffic">
        {item.traffic.map((trafficItem, idx) => (
          <div key={idx} className="detailing-item__traffic-item">{trafficItem}</div>
        ))}
      </div>
      <div className="detailing-item__date-container detailing-list__column--date">
        {item.date.map((dateItem, idx) => (
          <div key={idx} className="detailing-item__date-item">{dateItem}</div>
        ))}
      </div>
    </div>
  );
};
